import { t } from 'i18next';
import { noop } from 'lodash-es';
import { useCallback } from 'react';

import { InfiniteQuery, InfiniteQueryOption } from './constants';

const data: InfiniteQueryOption[] = [
  {
    label: t('dispatch.dispatch_v2.filters.potential_duplicates'),
    value: 'true',
  },
];

export default function useTicketPotentialDuplicateInfiniteQuery(): InfiniteQuery {
  const noopFn = useCallback(() => {
    return noop;
  }, []);

  return {
    clear: noopFn,
    data,
    fetch: noopFn,
    fetchMore: undefined,
    isDummyQuery: true,
  };
}
